module.exports = __webpack_public_path__ + "img/X_white.3e1c4a3e.svg";